import { z } from 'zod';
import {
  OldPasswordValidation,
  NewPasswordValidation,
  ConfirmNewPasswordValidation,
} from 'shared/validation/validationTemplates';

export const ChangePasswordFormValidation = OldPasswordValidation.and(NewPasswordValidation).and(
  ConfirmNewPasswordValidation,
);

export type TChangePasswordFormType = z.infer<typeof ChangePasswordFormValidation>;
